import { createContext } from 'react';
import { io } from 'socket.io-client';

//const backendURL = 'wss://inf124recipeshare.us-east-2.elasticbeanstalk.com';

const socket = io(process.env.REACT_APP_API_URL, {
    transports: ['websocket'],
    withCredentials: true
});
const SocketContext = createContext();

export { SocketContext, socket };